import React from 'react'

export default function IconComentario({size = 10, color = "#252428"}){
    return (
        <svg width={size} height={size} viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 0H0V8H8L10 10V0Z" fill={color}/>
        </svg>
    )
}